import { useApolloClient } from '@apollo/client';
import { useCallback } from 'react';
import { type LocalVariantSpecsFragment } from '../../../api/fragments/LocalVariantSpecs';
import { type FormValues } from '../AddVehiclePage/AddVariantPage/types';
import {
    brochureUpdate,
    extractVariantIdFromImageUploadResponse,
    extractVariantIdFromResponse,
    imagesUpdates,
} from './helper';

const useHandleVariantAssetsUpdate = () => {
    const apolloClient = useApolloClient();

    return useCallback(
        async (variantId: string, values: FormValues, initialValues?: LocalVariantSpecsFragment) => {
            const { images, brochure } = values;

            let updatedVariantId = variantId;
            const { uploads: imageUploads, deletes: imageDeletes } = imagesUpdates(
                variantId,
                apolloClient,
                initialValues,
                images
            );

            if (imageDeletes.length) {
                const updated = await Promise.all(imageDeletes);
                updatedVariantId = extractVariantIdFromResponse(updated) ?? variantId;
            }
            const brochureUploads = brochureUpdate(variantId, apolloClient, initialValues, brochure);
            if (brochureUploads.length) {
                const updated = await Promise.all(brochureUploads);
                updatedVariantId = extractVariantIdFromResponse(updated) ?? variantId;
            }
            let updatedImages = [];
            if (imageUploads.length) {
                updatedImages = await Promise.all(imageUploads);
                updatedVariantId = extractVariantIdFromImageUploadResponse(updatedImages) ?? variantId;
            }

            // return latest updated variant id and updatedImages
            return {
                updatedVariantId,
                updatedImages,
            };
        },
        [apolloClient]
    );
};

export default useHandleVariantAssetsUpdate;
